// extracted by mini-css-extract-plugin
module.exports = {"formatsList":"ILael"};